import { Storage } from '@ionic/storage';

class DBStorage {
    private storage?: Storage

    constructor() {
        this.init();
    }

    init = async () => {
        const store = new Storage();
        this.storage = await store.create();
    }

    initRet = async () => {
        const store = new Storage();
        return await store.create();
    }

    set = async (key: string, value: any) => {
        return await this.storage?.set(key, value);
    }

    get = async (key: string) => {
        return await this.storage?.get(key);
    }

    hasKey = async (key: string) => {
        let exist = false;
        const keys = await this.storage!.keys()
        keys.forEach((item) => {
            if (item == key) {
                exist = true;
            }
        })
        
        return exist;
    }

    remove = async (key: string) => {
        return await this.storage?.remove(key);
    }
}

export default DBStorage